import React, { useReducer } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { globalPropTypes } from 'helpers';
import reducer, { defaultState, updateFieldCreator } from './reducer';
import ExportCertificatesReport from '../../../../../shared/Cis/Certificates/ExportReport/ExportCertificatesReport';
import { loadGlobalCisCertificatesAttributesCreator } from '../../../../../store/actionsCreators';

const MaExportCertificatesReport = ({ certificationBodies, memberAssociations, countries, loadCertificatesAttributes }) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  return (
    <ExportCertificatesReport
      state={state}
      updateFieldCreator={updateFieldCreator}
      dispatch={dispatch}
      loadCertificatesAttributes={loadCertificatesAttributes}
      certificationBodies={certificationBodies}
      memberAssociations={memberAssociations}
      countries={countries}
      type="ma"
    />
  );
};

MaExportCertificatesReport.propTypes = {
  certificationBodies: PropTypes.arrayOf(globalPropTypes.ChooseDataPropsTypes).isRequired,
  memberAssociations: PropTypes.arrayOf(globalPropTypes.ChooseDataPropsTypes).isRequired,
  countries: PropTypes.arrayOf(globalPropTypes.ChooseDataPropsTypes).isRequired,
  type: PropTypes.oneOf(['ipma', 'ma']),
};

MaExportCertificatesReport.defaultProps = {};

const mapStateToProps = ({ globals }) => ({
  countries: globals.countries,
  certificationBodies: globals.cis.certificationBodies,
  memberAssociations: globals.cis.clientMemberAssociations,
});

const mapDispatchToProps = (dispatch) => ({
  loadCertificatesAttributes: () => dispatch(loadGlobalCisCertificatesAttributesCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MaExportCertificatesReport);
